export interface Jobchecklist {
    id: number;
    description: string;
  };

export var displayColumns = [
  'description'
]

export var displayHeaders = [
  'Name'
]

// actual database columns
export var orderByColumns = [
  'description'
]

// for dropdown the options are set via ts file, so modify the code there
export const filterParameters = [
  { 
      name: 'created_at', 
      type: 'date_range', 
      operator: 'between', 
      label: 'Select Date Range' 
  },
  { 
      name: 'description', 
      type: 'string', 
      operator: 'like', 
      label: 'Description', 
  },
  { 
    name: 'order_by_columns', 
    type: 'multi_select', 
    operator: 'order_by_columns',
    values: displayHeaders.map((header, index) => ({
            label: header,
            value: orderByColumns[index]
        })),
    model_name:'jobchecklist',
    label: 'Select columns for order by' 
  }
]; 
